//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';

export default {
  name: 'DpRadioGroup',
  mixins: [Emitter],
  props: {
    value: { type: [String, Number], default: null },
    list: { type: Boolean, default: false },
  },
};
